// Due to a bug in Safari and how it handles position: sticky,
// this bug fix will add overflow-x: hidden; to both html and body
// only if the browser matches safari

// User Agent Testing
let userAgentString = navigator.userAgent;
let chromeAgent = userAgentString.indexOf('Chrome') > -1;
let safariAgent = userAgentString.indexOf('Safari') > -1;

if (chromeAgent && safariAgent) {
    safariAgent = false;
}

if (safariAgent) {
    document.documentElement.classList.add('overflow-x-hidden');
    document.body.classList.add('overflow-x-hidden');
}
